const $ = jQuery

export default function JobOffers () {
  const WRAPPERS = document.querySelectorAll('.mtt-job-offers')
  if (WRAPPERS.length > 0) {
    for (let i = 0; i < WRAPPERS.length; i++) {
      const WRAPPER = new JobOffersWrapper(WRAPPERS[i])
      WRAPPER.init()
    }
  }
}

class JobOffersWrapper {
  constructor (WRAPPER) {
    this.WRAPPER = WRAPPER
    this.LOADER = this.WRAPPER.querySelector('.mtt-job-offers__loader')
    this.PAGINATION_TARGET = this.WRAPPER.querySelector('.mtt-job-offers__pagination-target')
    this.TARGET = this.WRAPPER.querySelector('.mtt-job-offers__articles')
    if (this.INITIAL_COMPANY !== 0) {
      this.INITIAL_COMPANY = parseInt(this.WRAPPER.dataset.initialCompany)
    } else {
      this.INITIAL_COMPANY = this.getFirstCompany()
    }

    this.url = this.WRAPPER.getAttribute('data-main-url')

    this.data = {
      action: 'filter_job_offers',
      pagenumber: 1,
      category: this.getFirstCategory(),
      location: this.getFirstLocation(),
      company: this.INITIAL_COMPANY,
      url: this.url
    }
  }

  init () {
    this.categoriesHandler()
    this.locationsHandler()
    this.companiesHandler()
    this.paginationHandler()
    this.addSeeMoreFunctionality()
  }

  addSeeMoreFunctionality() {
    this.seeMoreButtons = this.WRAPPER.querySelectorAll('.show-more-btn')
    
    if (this.seeMoreButtons.length > 0) {
      for (let i = 0; i < this.seeMoreButtons.length; i++) {
        const BUTTON = this.seeMoreButtons[i]

        BUTTON.addEventListener('click', () => {
          BUTTON.classList.toggle('is-open')
          $(BUTTON).siblings('[data-hide="true"]').toggleClass('hide')

          if (BUTTON.classList.contains('is-open')) {
            BUTTON.innerHTML = 'Show less'
          } else {
            BUTTON.innerHTML = 'Show more'
          }
        })

        this.openSeeMoreIfParamSet(BUTTON)
      }
    }
  }

  openSeeMoreIfParamSet(button) {
    const url = new URLSearchParams(window.location.search)
    const catParam = url.get('category')
    const locationParam = url.get('location')
    const companyParam = url.get('company')

    if (catParam && button.getAttribute('data-param') === 'category') {
      button.click()
    }

    if(locationParam && button.getAttribute('data-param') === 'location') {
      button.click()
    }

    if(companyParam && button.getAttribute('data-param') === 'company') {
      button.click()
    }

  }


  categoriesHandler () {
    const CATEGORIES = this.WRAPPER.querySelectorAll('.mtt-job-offers__sidebar-item[data-category]')

    if (CATEGORIES.length > 0) {
      for (let i = 0; i < CATEGORIES.length; i++) {
        const CAT = CATEGORIES[i]

        CAT.addEventListener('click', () => {
          this.data.category = CAT.getAttribute('data-category')
          this.data.pagenumber = 1
          $(CAT).addClass('active').siblings().removeClass('active')
          this.loadPosts()
        })
      }
    }
  }

  locationsHandler () {
    const LOCATIONS = this.WRAPPER.querySelectorAll('.mtt-job-offers__sidebar-item[data-location]')

    if (LOCATIONS.length > 0) {
      for (let i = 0; i < LOCATIONS.length; i++) {
        const LOC = LOCATIONS[i]

        LOC.addEventListener('click', () => {
          this.data.location = LOC.getAttribute('data-location')
          this.data.pagenumber = 1
          $(LOC).addClass('active').siblings().removeClass('active')
          this.loadPosts()
        })
      }
    }
  }

  companiesHandler () {
    const COMPANIES = this.WRAPPER.querySelectorAll('.mtt-job-offers__sidebar-item[data-company]')

    if (COMPANIES.length > 0) {

      for (let i = 0; i < COMPANIES.length; i++) {
        const COM = COMPANIES[i]

        COM.addEventListener('click', () => {
          if (this.INITIAL_COMPANY !== 0) {
            this.data.company = this.INITIAL_COMPANY
          } else {
            this.data.company = COM.getAttribute('data-company')
          }
          this.data.pagenumber = 1
          $(COM).addClass('active').siblings().removeClass('active')
          this.loadPosts()
        })
      }
    }
  }

  paginationHandler () {
    const PAGINATION_TOGGLES = this.WRAPPER.querySelectorAll('.mtt-pagination__toggle')

    if (PAGINATION_TOGGLES.length > 0) {
      for (let i = 0; i < PAGINATION_TOGGLES.length; i++) {
        const TOGGLE = PAGINATION_TOGGLES[i]

        TOGGLE.addEventListener('click', (e) => {
          e.preventDefault()
          this.data.pagenumber = TOGGLE.getAttribute('data-page')
          this.loadPosts()
        })
      }
    }
  }

  getFirstCategory () {
    const ACTIVE_CAT = this.WRAPPER.querySelector('.mtt-job-offers__sidebar-item[data-category].active')
    const CATEGORY = ACTIVE_CAT ? ACTIVE_CAT.getAttribute('data-category') : 0
    return parseInt(CATEGORY)
  }

  getFirstLocation () {
    const ACTIVE_LOC = this.WRAPPER.querySelector('.mtt-job-offers__sidebar-item[data-location].active')
    const LOCATION = ACTIVE_LOC ? ACTIVE_LOC.getAttribute('data-location') : 0
    return parseInt(LOCATION)
  }

  getFirstCompany () {
    const ACTIVE_COM = this.WRAPPER.querySelector('.mtt-job-offers__sidebar-item[data-company].active')
    const COMPANY = ACTIVE_COM ? ACTIVE_COM.getAttribute('data-company') : 0
    return parseInt(COMPANY)
  }

  loadPosts () {
    this.beforeAjax()
    $.post(main_theme_objects.ajax_url, this.data,
      (response) => {
        if (response !== 0) {
          if (this.TARGET && 'markup' in response) this.TARGET.innerHTML = response.markup
          if (this.PAGINATION_TARGET && 'pagination' in response) this.PAGINATION_TARGET.innerHTML = response.pagination
          this.paginationHandler()
          this.afterAjax()
        }
      }
    )
  }

  beforeAjax () {
    this.showLoader()
  }

  afterAjax () {
    this.buildUrl()
    this.hideLoader()
    this.scrollTop()
  }

  showLoader () {
    this.LOADER && this.LOADER.classList.add('loader--show')
  }

  hideLoader () {
    this.LOADER && this.LOADER.classList.remove('loader--show')
  }

  buildUrl () {
    let parametersString = this.url
    const parameters = []

    // add pagenumber
    if ('pagenumber' in this.data && parseInt(this.data.pagenumber) > 1) {
      parametersString += `page/${this.data.pagenumber}/`
    }

    // add cat
    if ('category' in this.data && parseInt(this.data.category) !== 0) {
      parameters.push(`category=${this.data.category}`)
    }

    // add cat
    if ('location' in this.data && parseInt(this.data.location) !== 0) {
      parameters.push(`location=${this.data.location}`)
    }

    // add cat
    if (this.INITIAL_COMPANY === 0) {
      if ('company' in this.data && parseInt(this.data.company) !== 0) {
        parameters.push(`company=${this.data.company}`)
      }
    }

    if (parameters.length > 0) {
      for (let i = 0; i < parameters.length; i++) {
        parametersString += i === 0 ? '?' : '&'
        parametersString += parameters[i]
      }
    }

    window.history.pushState('job-offer', '', parametersString)
  }

  getScrollOffset () {
    let offset = 0
    const HEADER = document.getElementById('main_header')
    offset += HEADER ? HEADER.getBoundingClientRect().height : 0
    const ADMIN_BAR = document.getElementById('wpadminbar')
    offset += ADMIN_BAR ? ADMIN_BAR.getBoundingClientRect().height : 0
    return offset
  }

  scrollTop () {
    $('html, body').animate({
      scrollTop: $(this.WRAPPER).offset().top - this.getScrollOffset()
    }, 700)
  }
}
